import {v4} from 'uuid';

export class ExpertReportDataObject {
	/**
	 * @param {?string} [id=null]
	 * @param {?string} [patientId=null]
	 * @param {?string} [therapyId=null]
	 * @param {Date} [date=null]
	 * @param {string} [title='']
	 * @param {string} [content='']
	 * @param {ExpertReportSectionDataObject[]} [sections=[]]
	 * @param {?string} [typeId=null]
	 */
	constructor(
		id = null, patientId = null, therapyId = null, date = null, title = '', content = '', sections = [], 
		typeId = null
	) {
		this.id = id;
		this.patientId = patientId;
		this.therapyId = therapyId;
		this.date = date;
		this.title = title;
		this.content = content;
		this.sections = sections;
		this.typeId = typeId;
		
		this.GUIID = v4();
	}
}

export class ExpertReportSectionDataObject {
	/**
	 * @param {?string} [id=null] - ID of the expert report additional content section.
	 * @param {?string} [baseId=null] - ID of the section defined in the expert report type (template) on which this
	 * section is based on.
	 * @param {string} [name=''] - Name of the expert report additional content section.
	 * @param {string} [content=''] - Default content of the expert report additional content section.
	 * @param {number} [ordinal=0] - Ordinal number of the expert report additional content section.
	 * @param {string} [GUIID=v4()] - Unique ID of the expert report additional content section.
	 */
	constructor(id = null, baseId = null, name = '', content = '', ordinal = 0, GUIID = v4()) {
		this.id = id;
		this.baseId = baseId;
		this.name = name;
		this.content = content;
		this.ordinal = ordinal;

		this.GUIID = GUIID;
	}
}